module.exports = __webpack_public_path__ + "assets/img/init_pos_wallpaper5.adbecceb.png";